export function ReadField({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.6, color: '#9e9e9e' }}>
        {label}
      </div>
      <div style={{ fontSize: 13, color: value ? '#212121' : '#bdbdbd', marginTop: 2 }}>
        {value || '—'}
      </div>
    </div>
  );
}
